/* eslint-disable max-len */
export default {
  MESSAGES: {
    CURRENT_DELIVERY_STATUS: 'Estado atual da entrega',
    DATE: 'Data',
    DELIVERY_HISTORY: 'Histórico da entrega',
    HOUR: 'hora',
    OBSERVATIONS: 'Observações',
    STATUS: 'Estado'
  }
};
